import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location)
  useEffect(() => {
    if (location.pathname == "/") {
      navigate("/landing/");
    } else {
    }
  }, []);
  return (
    <>
      <Outlet />
    </>
  );
};

export default MainLayout;
